import { getSystemConfig } from '@/api/affairs'
import { useUserStore } from '@/stores/user'
import { useMiscStore } from '@/stores/misc'
export const initGlobalConfig = async () => {
    const userStore = useUserStore()
    const miscStore = useMiscStore()
    const islogin = userStore.isLoggedIn
    if (!islogin) {
        return
    }
    try {
        let domain_alias = window.location.href.split('//')[1].split('.')[0]
        const res = await getSystemConfig({ domain_alias })
        if (res.data && res.data.code === 200) {
            let arr = res.data.data.ai_functions || []
            console.log(arr)
            miscStore.setAIToolconfig(arr)
            miscStore.setClientID(res.data.data.client_id || null)
            
        }
    } catch (error) {
        return
    }
}
